export default {
    path: '/boss',
    redirect:'/boss/index',
    meta: {
        title: '老板看数',
        permissionCode: 'pcBossBan'
    },
    children: [
        {
            path: 'index',
            component: () => import("@/views/boss/project/index.vue"),
            meta: {
                title: "项目收支统计",
                permissionCode: "pcBossBanProject",
                keepAlive:true,
                name:'pcBossBanProjectForm'
            },
        },
        {
            path: 'supplier',
            component: () => import("@/views/boss/supplier/index.vue"),
            meta: {
                permissionCode: "pcBossBanSupplier",
                title: '供应商供应及支付统计',
                keepAlive:true,
                name:'pcBossBanSupplierForm'
            },
        },
        {
            path: 'class',
            component: () => import("@/views/boss/class/index.vue"),
            meta: {
                permissionCode: "pcBossBanClass",
                title: '班组支付统计',
                keepAlive:true,
                name:'pcBossBanClassForm'
            },
        },
    ]
}